import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { firestoreConnect, firebaseConnect } from 'react-redux-firebase';
import { Redirect } from 'react-router-dom';

import Spinner from './Spinner';
import AssetsList from './AssetsList';
import './Page.css';

import Header from './Header';

class Assets extends Component {
  state = {};

  render() {
    const { assetsList, auth } = this.props;
    // if (!auth.uid) return <Redirect to="/login" />;
    return (
      <div>
        <Header title="Materijali VK Rijeka" img="/images/gallery/2013/074.jpg" />
        <div className="container">
          <div className="row">
            <div id="content">{assetsList ? <AssetsList assetsList={assetsList} /> : <Spinner />}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  firebaseConnect(),
  firestoreConnect([
    {
      collection: 'assets',
      limit: 10,
      // orderBy: ['added', 'asc'],
    },
  ]),
  connect((state, props) => ({
    assetsList: state.firestore.ordered.assets,
    auth: state.firebase.auth,
  }))
)(Assets);



// WEBPACK FOOTER //
// ./src/components/Assets.js